// extracted by mini-css-extract-plugin
export var active = "_2m-b";
export var activeIndicator = "_2m-6";
export var animate = "_2m-a";
export var disabled = "_2m-c";
export var flat = "_2m-1";
export var fullWidth = "_2m-3";
export var lg = "_2m-9";
export var md = "_2m-8";
export var redoButtonTabGroup = "_2m-0";
export var sm = "_2m-7";
export var tabButton = "_2m-4";
export var tabButtonsContainer = "_2m-2";
export var xs = "_2m-5";